import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaMotorcycle, FaList, FaHeart, FaChevronRight, FaPlay } from 'react-icons/fa';
import ServiceTracker from '../../DELIVERY/Service/ServiceTracker';
import PendingReviewsSection from '../PendingReviewsSection';
import LiveMapSection from '../LiveMapSection';
import BottomSheet from '../../UI/BottomSheet';
import BackButton from '../../UI/BackButton';
import PassengerGuideCard from './components/PassengerGuideCard';
import PassengerShortcuts from './components/PassengerShortcuts';
import ShiftDriversList from './components/ShiftDriversList';
import './PassengerView.css';

const PassengerView = ({
    pickupPos, dropoffPos, handleMapClick, selectedDriver, setSelectedDriver, clearPositions
}) => {
    const navigate = useNavigate();
    const [sheetExpanded, setSheetExpanded] = useState(true);

    return (
        <div className="passenger-figma-container">
            {/* Map Section */}
            <div className="passenger-map-wrapper">
                <LiveMapSection 
                    pickupPos={pickupPos} 
                    dropoffPos={dropoffPos} 
                    handleMapClick={handleMapClick} 
                    selectedDriver={selectedDriver} 
                    setSelectedDriver={setSelectedDriver} 
                    clearPositions={clearPositions} 
                />
            </div>

            {/* Bottom Sheet for Passenger Actions */}
            <BottomSheet
                title="¿Qué necesitas hoy?"
                date={new Date().toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'short' })}
                variant="persistent"
                isExpanded={sheetExpanded}
                onToggle={setSheetExpanded}
                className="passenger-tasks-bottom-sheet"
            >
                <ServiceTracker />
                <PendingReviewsSection />

                {/* Tarjeta de Guía para nuevos */}
                <div className="mb-3">
                    <PassengerGuideCard />
                </div>

                {/* Quick Actions (Accesos directos) */}
                <div className="mb-3">
                    <PassengerShortcuts />
                </div>

                {/* Conductores de turno activos */}
                <ShiftDriversList 
                    pickupPos={pickupPos}
                    selectedDriver={selectedDriver}
                    onSelectDriver={setSelectedDriver}
                />
            </BottomSheet>
        </div>
    );
};

export default PassengerView;
